import { render, staticRenderFns } from "./marketplaceCreate.vue?vue&type=template&id=31185410&scoped=true&"
import script from "./marketplaceCreate.vue?vue&type=script&lang=js&"
export * from "./marketplaceCreate.vue?vue&type=script&lang=js&"
import style0 from "./marketplaceCreate.vue?vue&type=style&index=0&id=31185410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31185410",
  null
  
)

export default component.exports